import { render, staticRenderFns } from "./RuleDetail.vue?vue&type=template&id=4539bc7d&"
import script from "./RuleDetail.vue?vue&type=script&lang=ts&"
export * from "./RuleDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports